import { render } from "./dropdownColorPickerView.vue?vue&type=template&id=e3adc87e"
import script from "./dropdownColorPickerView.vue?vue&type=script&lang=js"
export * from "./dropdownColorPickerView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__